// extracted by mini-css-extract-plugin
export default {"root":"LayoutWrapperSideNav_root__CbjMp","tabs":"LayoutWrapperSideNav_tabs__yeVmV","tab":"LayoutWrapperSideNav_tab__+WjuL"};